import { Component } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

export default class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error('[ErrorBoundary]', error, info); }

  render() {
    if (this.state.error) {
      return (
        <div className="flex flex-col items-center justify-center py-20 gap-4">
          <AlertTriangle size={32} className="text-bear opacity-60" />
          <div className="text-center">
            <p className="font-semibold text-txt-primary">Something went wrong</p>
            <p className="text-xs text-txt-muted font-mono mt-1">{this.state.error?.message}</p>
          </div>
          <button
            onClick={() => this.setState({ error: null })}
            className="btn-ghost flex items-center gap-2 text-xs"
          >
            <RefreshCw size={12} /> Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
